import React from 'react';
import {
  Container, Link, styled, Typography,
} from '@mui/material';

interface EnvironmentBannerProps {
  environment: string;
  version: string;
  explanationText: string;
  url?: string;
  urlText?: string;
}

const OuterContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
}));

const InnerContainer = styled('div')(({ theme }) => ({
  zIndex: 2,
  borderBottom: `${theme.palette.neutral.main} 1px solid `,
  backgroundColor: theme.palette.neutral.light,
  display: 'flex',
  paddingTop: '16px',
  padding: '16px 24px',
}));

const EnvironmentText = styled(Typography)(() => ({
  fontWeight: 'bold',
  paddingRight: '16px',
  textTransform: 'uppercase',
}));

const VersionText = styled(Typography)(() => ({
  paddingRight: '16px',
}));

const Spacer = styled('span')(() => ({
  flex: '1 1 auto',
}));

const StyledLink = styled(Link)(() => ({
  paddingLeft: '22px',
  fontWeight: 'bold',
}));

const EnvironmentBanner: React.FC<EnvironmentBannerProps> = (props: EnvironmentBannerProps) => {
  const preventDefault = (event: React.SyntheticEvent): void => event.preventDefault();
  return (
    <OuterContainer>
      <Container>
        <InnerContainer>
          <EnvironmentText variant="body1" color="primary">
            {props.environment}
          </EnvironmentText>
          <VersionText variant="body1" color="primary">
            {props.version}
          </VersionText>
          <Spacer />
          <Typography>
            {props.explanationText}
          </Typography>
          {props.url ? (
            <Typography>
              <StyledLink onClick={preventDefault} href={props.url}>{props.urlText}</StyledLink>
            </Typography>
          ) : null}

        </InnerContainer>

      </Container>
    </OuterContainer>
  );
};

EnvironmentBanner.defaultProps = {
  url: undefined,
  urlText: undefined,
};

export default EnvironmentBanner;
